export const SET_LANGUAGE = 'SET_LANGUAGE';
export const INITIALIZE_LANGUAGES = 'INITIALIZE_LANGUAGES';
